import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store.js";
import "@ant-design/v5-patch-for-react-19";

// Admin had no chunk-error recovery despite lazy-loading every CASS page + the
// DashAI card registry, so a stale tab white-screened on a removed chunk after
// a deploy. Reuse web's handler (admin→web imports allowed).
import { installChunkErrorReload } from "@web/utils/chunkReload";

installChunkErrorReload();

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
);
